var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerDowntimeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5475_62809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.32667 1.74134L2.46901 5.52653C1.6579 6.1574 1 7.50024 1 8.51863V15.1968C1 17.2877 2.70334 19 4.7942 19H15.2305C17.3214 19 19.0247 17.2877 19.0247 15.2058V8.6448C19.0247 7.55431 18.2947 6.1574 17.4025 5.53554L11.8329 1.63319C10.5711 0.749983 8.54334 0.795045 7.32667 1.74134Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0681 14.0531L10.2829 10.2679L8.84095 12.4308L5.957 9.54688",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2655 14.0525H14.0679V12.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5475_62809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerDowntimeLight);
export default __webpack_public_path__ + "static/media/server-downtime-light.0b9d82fac9687c1ea43abe2c66ecfd06.svg";
export { ForwardRef as ReactComponent };